import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import { toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        margin: toCssValue([3, 0]),
    },
    default: {
        height: 28,
        marginRight: 5,
        color: theme.color.font.dark,
    },
});
const Radiobox = (props) => {
    const { classes, children, input, testId = 'Radiobox', ...others } = props;
    return (React.createElement("div", { className: classes.container, "data-testid": `${testId}` },
        React.createElement(FormControl, null,
            React.createElement(RadioGroup, Object.assign({ "data-testid": `${testId}-input`, classes: { root: classes.default } }, input, others), children))));
};
const ComposedRadiobox = compose(withStyles(styles, { withTheme: true }), pure)(Radiobox);
ComposedRadiobox.displayName = 'Radiobox';
export default ComposedRadiobox;
//# sourceMappingURL=Radiobox.js.map